import { advancedSettingsActionTypes } from '@constants/actionTypes';
import { logError } from '@utils/usefulFuncs';
import { getAdvancedSettingsForMode } from '@constants/advancedSettings';

const defaultState = {
  advancedSettingsFields: null,
  advancedSettingsValues: {},
  loadedMode: null,
  loadingMode: null,
  loadError: null,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case advancedSettingsActionTypes.setAdvancedSettings: {
      return {
        ...state,
        advancedSettingsValues: {
          ...state.advancedSettingsValues,
          ...action.payload,
        },
      };
    }
    case advancedSettingsActionTypes.setAdvancedSettingsLoading: {
      const mode = action.payload?.mode || null;
      return {
        ...state,
        loadingMode: mode,
        loadError: null,
      };
    }
    case advancedSettingsActionTypes.setAdvancedSettingsLoaded: {
      const { mode, startingValues } = action.payload || {};
      const sameMode = mode && state.loadedMode === mode;
      return {
        ...state,
        loadingMode: null,
        loadError: null,
        loadedMode: mode || state.loadedMode,
        advancedSettingsValues: sameMode ? state.advancedSettingsValues : startingValues || {},
      };
    }
    case advancedSettingsActionTypes.setAdvancedSettingsError: {
      return {
        ...state,
        loadingMode: null,
        loadError: action.payload || { error: 'Unknown error' },
      };
    }
    case advancedSettingsActionTypes.clearAdvancedSettings: {
      return {
        ...state,
        advancedSettingsValues: {},
      };
    }

    case advancedSettingsActionTypes.showAdvancedSettings: {
      const tool = action.payload;
      const entry = getAdvancedSettingsForMode(tool);
      const fields = entry?.fields ?? null;
      if (!Array.isArray(fields)) {
        logError('Missing fields for advanced settings to show for tool', tool);
        return state;
      }
      return {
        ...state,
        advancedSettingsFields: fields,
      };
    }

    case advancedSettingsActionTypes.hideAdvancedSettings: {
      return {
        ...state,
        advancedSettingsFields: null,
      };
    }

    default:
      return state;
  }
}
